import React, { useState } from 'react';

import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import CalendarEventDetails from '@/modules/calendar/components/data-calendar/details/calendar-event-details';
import HotList from '@/modules/calendar/components/hot-list/hot-list';
import { WidgetHost, NewsWidget } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';

function HotListMainView() {
  const [event, setEvent] = useState<NewsEvent>();

  if (event)
    return (
      <div className={'h-100 overflow-auto'}>
        <CalendarEventDetails
          newsEvent={event}
          onArticleClick={() => {}}
          onClose={() => setEvent(undefined)}
        />
      </div>
    );

  return (
    <div className={'h-100 overflow-auto'}>
      <HotList eventClick={event => setEvent(event)} />
    </div>
  );
}

export class HotListWidget implements NewsWidget {
  defaultTitle = 'Hot List';
  readonly id = '/hot-list';

  async hasPermission(permissions: string[]) {
    return true;
  }

  initialize(host: WidgetHost) {}
  get headerPanel(): JSX.Element {
    return <>🔥 Hot List</>;
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get shortTitle(): JSX.Element {
    return <>🔥</>;
  }

  get mainPanel(): JSX.Element {
    return <HotListMainView />;
  }

  get routes(): RouteObject[] {
    return [
      {
        path: `/hot-list`,
        element: <HotListMainView />,
      },
    ];
  }

  get defaultRoute(): string {
    return `/hot-list`;
  }
}
